import type { Sale, SalePaymentSummary } from "../types";

function sumFromPayments(sale: Pick<Sale, "finalValue" | "salePayments">): SalePaymentSummary {
  const finalValue = parseFloat(String(sale.finalValue));
  let totalConfirmed = 0;
  let totalPending = 0;
  for (const p of sale.salePayments ?? []) {
    const a = parseFloat(String(p.amount));
    const st = String(p.status).toLowerCase();
    if (st === "confirmed") totalConfirmed += a;
    else if (st === "pending") totalPending += a;
  }
  return {
    finalValue,
    totalConfirmed,
    totalPending,
    remainingToPay: Math.max(0, finalValue - totalConfirmed),
    isFullyPaid: totalConfirmed >= finalValue - 1e-9,
  };
}

export function computeSalePaymentSummary(sale: Sale): SalePaymentSummary {
  if (sale.salePayments === undefined) {
    if (sale.paymentSummary) return sale.paymentSummary;
  }
  return sumFromPayments(sale);
}
